import type { SVGProps } from 'react';

/** 20×20 stroke icons (no icon font, no external set). */
const paths = {
  dashboard: 'M3.5 3h5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zM11.5 3h5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zM3.5 11h5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5zM11.5 11h5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5h-5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5z',
  stake: 'M5 9h10a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1v-7a1 1 0 011-1zM7 9V6a3 3 0 016 0v3M10 12.5v2',
  bond: 'M4 4h12v12H4zM4 8h12M8 4v12',
  swap: 'M4 7h11l-3-3M16 13H5l3 3',
  liquidity: 'M10 2c3 4 5 6.5 5 9a5 5 0 01-10 0c0-2.5 2-5 5-9z',
  referral: 'M7 8a3 3 0 100-6 3 3 0 000 6zM2 17c0-3 2.2-5 5-5s5 2 5 5M14 8a2.5 2.5 0 100-5M14 12c2.2 0 4 1.7 4 4.5',
  docs: 'M5 2h7l4 4v12H5zM12 2v4h4M8 10h6M8 13h6',
  admin: 'M10 2l7 4v8l-7 4-7-4V6zM10 7.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z',
  more: 'M4 10h.01M10 10h.01M16 10h.01',
  close: 'M5 5l10 10M15 5L5 15',
  copy: 'M7 7h9v9H7zM4 13V4h9',
  external: 'M8 4H4v12h12v-4M11 3h6v6M17 3l-8 8',
  wallet: 'M3 6h14v10H3zM3 6l10-3v3M13 11h.01',
  bell: 'M5 14V9a5 5 0 0110 0v5l1.5 2h-13zM8.5 18.5h3',
  sparkle: 'M10 2l1.6 4.8L16 8.5l-4.4 1.7L10 15l-1.6-4.8L4 8.5l4.4-1.7zM16 13l.7 1.8 1.8.7-1.8.7L16 18l-.7-1.8-1.8-.7 1.8-.7z',
  chevron: 'M6 8l4 4 4-4',
  info: 'M10 18a8 8 0 100-16 8 8 0 000 16zM10 9v5M10 6h.01',
  up: 'M10 15V5M5.5 9.5L10 5l4.5 4.5',
  down: 'M10 5v10M5.5 10.5L10 15l4.5-4.5',
  arrow: 'M4 10h12M11 5l5 5-5 5',
  check: 'M4.5 10.5l3.5 3.5 7.5-8',
  star: 'M10 2.5l2.3 4.7 5.2.8-3.8 3.6.9 5.2-4.6-2.4-4.6 2.4.9-5.2L2.5 8l5.2-.8z',
} as const;

export type IconName = keyof typeof paths;

export function Icon({ name, ...rest }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...rest}>
      <path d={paths[name]} />
    </svg>
  );
}
